module.exports = __webpack_public_path__ + "static/media/play-stone-boss-4-active.b1cb32cc.png";